import { AIModal } from "@clockwise/web-commons/src/ui/ai-modal/AIModal";
import { getUrlForFeature } from "@clockwise/web-commons/src/util/routes.util";
import { useRouter } from "found";
import React, { useEffect } from "react";
import { useLocalStorage } from "usehooks-ts";
import { TrackingEvents, track } from "../../util/analytics.util";

export const AIModalWebapp = () => {
  const { router } = useRouter();
  const [aiModalViewed, setAIModalViewed] = useLocalStorage<boolean>(
    "ClockwiseAI:AICtaViewed",
    false,
  );

  useEffect(() => {
    if (!aiModalViewed) {
      track(TrackingEvents.AI_WEBAPP_CTA.MODAL_SHOWN);
    }
  }, [aiModalViewed]);

  const onDismiss = () => {
    setAIModalViewed(true);
    track(TrackingEvents.AI_WEBAPP_CTA.DISMISS_BUTTON_CLICKED);
  };

  const goToAIScheduler = () => {
    setAIModalViewed(true);
    track(TrackingEvents.AI_WEBAPP_CTA.GO_TO_BUTTON_CLICKED);
    router.push(getUrlForFeature("ai", { relative: true }));
  };

  if (aiModalViewed) {
    return null;
  }

  return (
    <AIModal
      primaryAction={goToAIScheduler}
      secondaryAction={onDismiss}
      primaryActionText="Check it out"
      secondaryActionText="Dismiss"
      title="The most dynamic calendar you've ever experienced"
      description="As your calendar assistant, Clockwise can handle all of your scheduling needs and organize your day seamlessly."
    />
  );
};
